import { CATCH_POSITIONS_MINZOOM } from '../constants/mapLayers/catchPositions';
import { POINTS_OF_INTEREST_MINZOOM } from '../constants/mapLayers/pointsOfInterest';
import { WAYPOINTS_MINZOOM } from '../constants/mapLayers/waypoints';
import { ExploreQueryParams } from '../types/types';

const DEFAULT_ZOOM_LEVEL = 12;

export function getInitialZoomLevel({ zoom, drawerView }: ExploreQueryParams): number {
  if (zoom !== undefined) {
    return zoom;
  }

  if (drawerView === 'catch') {
    return CATCH_POSITIONS_MINZOOM;
  }
  if (drawerView === 'poi') {
    return POINTS_OF_INTEREST_MINZOOM;
  }
  if (drawerView === 'waypoint') {
    return WAYPOINTS_MINZOOM;
  }

  return DEFAULT_ZOOM_LEVEL;
}
